import { Action, createReducer, on } from '@ngrx/store';
import {
    amJobsForSubmittalsFail,
    amJobsForSubmittalsLoaded,
    amLoadJobsLookups,
    amLoadJobsLookupsFail,
    amLoadJobsLookupsSuccess,
    amSubmittalJobsLoaded,
    amSubmittalReassign,
    amSubmittalReassignFailure,
    amSubmittalReassignSuccess,
    amLoadOfferRecruitersSuccess,
    amLoadSubmittalRemovalReasons,
    amLoadSubmittalRemovalReasonsSuccess,
    amLoadSubmittalRemovalReasonsFail,
    getVendorInfoForSubmittals,
    getVendorInfoForSubmittalsSuccess,
    getFacilityPlacement,
    getSubmittalStatusesSuccess,
    accountManagerDashboardAlertSuccess,
    accountManagerDashboardAlertFailure,
    amBulkRemoveFromLiveList,
    amBulkRemoveFromLiveListSuccess,
    amBulkRemoveFromLiveListFail,
    resetBulkRemoveFromLiveListResult
} from './actions/account-managers.actions';
import {
    loadJobRecommendations,
    loadJobRecommendationsSuccess,
    loadJobRecommendationsFailure,
    updateRecommendation,
    updateRecommendationSuccess,
    updateRecommendationFailure
} from './actions/job-recommendations.actions';
import { bookedCandidateDetailsActions } from './actions/booked-candidate-details.actions';
import { AccountManagersState } from './state/account-managers.state';
import * as NoteActions from 'src/app/root-store/account-managers-store/actions/workforce-notes.actions';
import { ActionType } from 'src/app/accountmanagers/details/flyouts/recommendations-flyout/models/job-recommendation-categories-actions.model';

export const accountManagersFeatureKey = 'account-managers';

export const initialState: AccountManagersState = {
    isLoading: false,
    uploadResult: false,
    error: undefined,
    submittalReassignResult: false,
    submittalReassignError: null,
    lookups: undefined,
    submittalJobs: [],
    offerRecruiters: [],
    submittalRemovalReasons: [],
    removeFromLiveListResult: undefined,
    bulkRemoveFromLiveListResult: undefined,
    permissions: undefined,
    candidateProfileInformation: undefined,
    placementInformation: undefined,
    travelDetails: undefined,
    flightBookingInformation: undefined,
    placementNotes: [],
    hotelDetails: undefined,
    additionalInfo: [],
    facilitySystemAdditionalInfo: [],
    lookupTravelStatuses: [],
    lookupTravelPlanTypes: [],
    lookupGenderTypes: [],
    lookupStateCodes: [],
    worforceNotes: {
        notes: [],
        loading: false,
        error: undefined
    },
    jobRecommendations: {
        recommendations: [],
        jobRecommendationNumTodos: 0,
        jobRecommendationNumCompleted: 0,
        jobRecommendationNumDismissed: 0,
        showJobRecommendations: false,
        showTodoDivider: false,
        showDismissedDivider: false
    },
    submittalVendorInfo: [],
    facilityPlacement: undefined,
    statuses: [],
    isHubConnectionActive: false,
    accountManagerDashboardAlertData: undefined,
    accountManagerDashboardAlertDataError: undefined
};

export const accountManagersReducer = createReducer(
    initialState,

    // AM Submittal Reassignment
    on(amSubmittalReassignSuccess, (state, action) => ({
        ...state,
        submittalReassignResult: action.result
    })),

    on(amSubmittalReassign, (state, action) => ({
        ...state,
        submittalReassignResult: false
    })),

    on(amSubmittalReassignFailure, (state, action) => ({
        ...state,
        submittalReassignError: action.error
    })),

    on(amLoadJobsLookups, (state, action) => ({
        ...state,
        error: undefined
    })),

    on(amLoadJobsLookupsSuccess, (state, action) => ({
        ...state,
        lookups: action.lookups,
        error: undefined
    })),

    on(amLoadJobsLookupsFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    on(amJobsForSubmittalsLoaded, (state, action) => ({
        ...state,
        submittalJobs: action.jobs
    })),

    on(amJobsForSubmittalsFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    on(amSubmittalJobsLoaded, (state, action) => ({
        ...state,
        submittalJobs: state.submittalJobs.filter(
            (e) => !action.jobs || !action.jobs.some((r) => e.submittalId === r.submittalId && e.jobId === r.jobId)
        )
    })),
    on(amLoadOfferRecruitersSuccess, (state, action) => ({
        ...state,
        offerRecruiters: action.recruiterIds
    })),

    on(amLoadSubmittalRemovalReasons, (state) => ({
        ...state,
        isLoading: true,
        error: undefined
    })),

    on(amLoadSubmittalRemovalReasonsSuccess, (state, action) => ({
        ...state,
        isLoading: false,
        submittalRemovalReasons: action.submittalRemovalReasons,
        error: undefined
    })),

    on(amLoadSubmittalRemovalReasonsFail, (state) => ({
        ...state,
        isLoading: false
    })),

    on(amBulkRemoveFromLiveList, (state) => ({
        ...state,
        bulkRemoveFromLiveListResult: undefined
    })),

    on(amBulkRemoveFromLiveListSuccess, (state) => ({
        ...state,
        bulkRemoveFromLiveListResult: true
    })),

    on(amBulkRemoveFromLiveListFail, (state) => ({
        ...state,
        bulkRemoveFromLiveListResult: false
    })),

    on(resetBulkRemoveFromLiveListResult, (state) => ({
        ...state,
        bulkRemoveFromLiveListResult: undefined
    })),

    on(bookedCandidateDetailsActions.getWdpPlacementInformation, (state, action) => ({
        ...state,
        placementInformation: undefined
    })),

    on(bookedCandidateDetailsActions.getWdpPlacementInformationSuccess, (state, action) => ({
        ...state,
        placementInformation: action.placementsInformation
    })),

    on(bookedCandidateDetailsActions.getWdpPlacementInformationFailure, (state, action) => ({
        ...state,
        placementInformation: {}
    })),

    on(bookedCandidateDetailsActions.getWdpCandidateProfile, (state, action) => ({
        ...state,
        candidateProfileInformation: undefined
    })),

    on(bookedCandidateDetailsActions.getWdpCandidateProfileSuccess, (state, action) => ({
        ...state,
        candidateProfileInformation: action.candidateProfile
    })),

    on(bookedCandidateDetailsActions.getWdpCandidateProfileFailure, (state, action) => ({
        ...state,
        candidateProfileInformation: {}
    })),

    on(
        bookedCandidateDetailsActions.getWdpFlightBookingInformationSuccess,
        bookedCandidateDetailsActions.updateWdpFlightBookingInformationSuccess,
        (state, action) => ({
            ...state,
            error: undefined,
            flightBookingInformation: action.flightBookingInformation ?? []
        })
    ),

    on(
        bookedCandidateDetailsActions.getWdpFlightBookingInformationFailure,
        bookedCandidateDetailsActions.updateWdpFlightBookingInformationFailure,
        (state, action) => ({
            ...state,
            error: action.type,
            flightBookingInformation: state.flightBookingInformation ? [...state.flightBookingInformation] : []
        })
    ),

    on(
        bookedCandidateDetailsActions.getWdpTravelDetailsSuccess,
        bookedCandidateDetailsActions.updateWdpTravelDetailsSuccess,
        (state, action) => ({
            ...state,
            error: undefined,
            travelDetails: action.travelDetails ?? {
                travelStatusId: 0,
                orientationDay: '',
                travelPlanTypeId: 0,
                departureAirportCode: '',
                estimateMileage: 0,
                legalNameOnGovtIssuedId: '',
                dobOnGovtIssuedId: '',
                genderOnGovtIssuedId: 0,
                stateOnGovtIssuedId: ''
            }
        })
    ),

    on(
        bookedCandidateDetailsActions.getWdpTravelDetailsFailure,
        bookedCandidateDetailsActions.updateWdpTravelDetailsFailure,
        (state, action) => ({
            ...state,
            error: action.type,
            travelDetails: { ...state.travelDetails }
        })
    ),

    on(bookedCandidateDetailsActions.getWfdHotelDetailsSuccess, (state, action) => ({
        ...state,
        error: undefined,
        hotelDetails: action.hotelDetails ?? {
            hotelName: '',
            workforceDisruptionProfileId: 0,
            id: 0
        }
    })),

    on(bookedCandidateDetailsActions.updateWfdHotelDetailsSuccess, (state, action) => ({
        ...state,
        error: undefined,
        hotelDetails: action.hotelDetailsPayload ?? {
            hotelName: '',
            workforceDisruptionProfileId: 0,
            id: 0
        }
    })),

    on(bookedCandidateDetailsActions.getWfdHotelDetailsFailure, (state, action) => ({
        ...state,
        error: action.type,
        hotelDetails: {
            hotelName: '',
            workforceDisruptionProfileId: 0,
            id: 0
        }
    })),

    on(bookedCandidateDetailsActions.updateWfdHotelDetailsFailure, (state, action) => ({
        ...state,
        error: action.type,
        hotelDetails: {
            hotelName: state.hotelDetails.hotelName,
            workforceDisruptionProfileId: state.hotelDetails.workforceDisruptionProfileId,
            id: state.hotelDetails.id
        }
    })),

    on(bookedCandidateDetailsActions.getWfdAdditionalInfoSuccess, (state, action) => ({
        ...state,
        error: undefined,
        additionalInfo: action.additionalInfo
    })),

    on(bookedCandidateDetailsActions.getWfdAdditionalInfoError, (state, action) => ({
        ...state,
        error: action.type,
        additionalInfo: state.additionalInfo
    })),

    on(bookedCandidateDetailsActions.updateWfdAdditionalInfoSuccess, (state, action) => ({
        ...state,
        error: action.type,
        additionalInfo: action.additionalInfo
    })),

    on(bookedCandidateDetailsActions.updateWfdAdditionalInfoError, (state, action) => ({
        ...state,
        error: action.type,
        additionalInfo: state.additionalInfo
    })),

    on(bookedCandidateDetailsActions.getWfdFacilitySystemAdditionalInfoSuccess, (state, action) => ({
        ...state,
        error: undefined,
        facilitySystemAdditionalInfo: action.additionalInfo
    })),

    on(bookedCandidateDetailsActions.getWfdFacilitySystemAdditionalInfoError, (state, action) => ({
        ...state,
        error: action.type,
        facilitySystemAdditionalInfo: state.facilitySystemAdditionalInfo
    })),

    on(bookedCandidateDetailsActions.updateWfdFacilitySystemAdditionalInfoSuccess, (state, action) => ({
        ...state,
        error: action.type
    })),

    on(bookedCandidateDetailsActions.updateWfdFacilitySystemAdditionalInfoError, (state, action) => ({
        ...state,
        error: action.type,
        facilitySystemAdditionalInfo: state.facilitySystemAdditionalInfo
    })),

    on(bookedCandidateDetailsActions.getWdpTravelStatusesSuccess, (state, action) => ({
        ...state,
        lookupTravelStatuses: action.travelStatuses
    })),

    on(bookedCandidateDetailsActions.getWdpTravelPlanTypesSuccess, (state, action) => ({
        ...state,
        lookupTravelPlanTypes: action.travelPlanTypes
    })),

    on(bookedCandidateDetailsActions.getWdpGenderTypesSuccess, (state, action) => ({
        ...state,
        lookupGenderTypes: action.genderTypes
    })),

    on(bookedCandidateDetailsActions.getWdpStateCodesSuccess, (state, action) => ({
        ...state,
        lookupStateCodes: action.stateCodes
    })),

    on(
        NoteActions.loadNotes,
        (state): AccountManagersState => ({
            ...state,
            worforceNotes: {
                ...state.worforceNotes,
                loading: true
            }
        })
    ),

    on(
        NoteActions.loadNotesSuccess,
        (state, action): AccountManagersState => ({
            ...state,
            worforceNotes: {
                ...state.worforceNotes,
                loading: false,
                notes: action.notes
            }
        })
    ),

    on(
        NoteActions.loadNotesFailure,
        (state, action): AccountManagersState => ({
            ...state,
            worforceNotes: {
                ...state.worforceNotes,
                loading: false,
                error: action.error
            }
        })
    ),

    on(
        NoteActions.addNote,
        (state): AccountManagersState => ({
            ...state,
            worforceNotes: {
                ...state.worforceNotes,
                loading: true
            }
        })
    ),

    on(
        NoteActions.addNotesSuccess,
        (state, action): AccountManagersState => ({
            ...state,
            worforceNotes: {
                ...state.worforceNotes,
                notes: [action.returnNote, ...state.worforceNotes.notes],
                loading: false
            }
        })
    ),

    on(
        NoteActions.addNotesFailure,
        (state, action): AccountManagersState => ({
            ...state,
            worforceNotes: {
                ...state.worforceNotes,
                error: action.error,
                loading: false
            }
        })
    ),

    on(
        loadJobRecommendations,
        (state): AccountManagersState => ({
            ...state,
            error: undefined
        })
    ),

    on(
        loadJobRecommendationsSuccess,
        (state, action): AccountManagersState => ({
            ...state,
            jobRecommendations: {
                ...state.jobRecommendations,
                recommendations: action.recommendations,
                jobRecommendationNumTodos: action.numTodos,
                jobRecommendationNumCompleted: action.numCompleted,
                jobRecommendationNumDismissed: action.numDismissed,
                showJobRecommendations: action.numTodos > 0 || action.numCompleted > 0 || action.numDismissed > 0
            },
            error: undefined
        })
    ),

    on(
        loadJobRecommendationsFailure,
        (state, action): AccountManagersState => ({
            ...state,
            error: action.error
        })
    ),

    on(
        updateRecommendation,
        (state): AccountManagersState => ({
            ...state
        })
    ),

    on(updateRecommendationSuccess, (state, action): AccountManagersState => {
        const newRecommendationList = state.jobRecommendations.recommendations.map((recommendation) => {
            if (recommendation.actionId === action.recommendation.actionId) {
                return {
                    ...recommendation,
                    actionType: action.recommendation.actionType
                };
            } else {
                return recommendation;
            }
        });
        const numTodos = newRecommendationList.filter(
            (f) => f.actionType === ActionType.Todo && (f.recommendAction || f.isCustomAction)
        ).length;
        const numCompleted = newRecommendationList.filter((f) => f.actionType === ActionType.Completed).length;
        const numDismissed = newRecommendationList.filter((f) => f.actionType === ActionType.Dismissed).length;

        return {
            ...state,
            jobRecommendations: {
                ...state.jobRecommendations,
                recommendations: newRecommendationList,
                jobRecommendationNumTodos: numTodos,
                jobRecommendationNumCompleted: numCompleted,
                jobRecommendationNumDismissed: numDismissed,
                showJobRecommendations: numTodos > 0 || numCompleted > 0 || numDismissed > 0
            }
        };
    }),

    on(
        updateRecommendationFailure,
        (state, action): AccountManagersState => ({
            ...state,
            error: action.error
        })
    ),
    on(
        getVendorInfoForSubmittals,
        (state, action): AccountManagersState => ({
            ...state,
            submittalVendorInfo: []
        })
    ),
    on(
        getVendorInfoForSubmittalsSuccess,
        (state, action): AccountManagersState => ({
            ...state,
            submittalVendorInfo: action.vendorInfo
        })
    ),
    on(getFacilityPlacement, (state, action) => ({
        ...state,
        facilityPlacement: action.facilityPlacement
    })),
    on(getSubmittalStatusesSuccess, (state, action) => {
        const list = action.statuses.map((t) => ({
            ...t,
            subStatuses: t.subStatuses?.map((s) => ({ ...s, selected: false })),
            selected: false
        }));

        return {
            ...state,
            statuses: list
        };
    }),

    // successful dashboard alert
    on(accountManagerDashboardAlertSuccess, (state, action) => ({
        ...state,
        accountManagerDashboardAlertData: action.data
    })),

    // dashboard alert failure
    on(accountManagerDashboardAlertFailure, (state, action) => ({
        ...state,
        accountManagerDashboardAlertDataError: action.error
    }))
);

export function reducer(state: AccountManagersState | undefined, action: Action) {
    return accountManagersReducer(state, action);
}
